// extracted by mini-css-extract-plugin
export default {"info":"delete-modal_info__zufbx","text":"delete-modal_text__g3dF1","source":"delete-modal_source__S37Xa","button":"delete-modal_button__vxnUV"};